import http from '@/libs/http';
import { catchError } from '@bigo/helpers';
import { brpcAnchorBrokerFrontQryAgentInfo } from '@/api';
import { STATUS_CODE } from '@/constants';
import { AccountRole } from '@/constants/enum';
import { bigoDbQryGetUserInfoFromServer6645 } from '@/api/yapi-req-6645';

/** @enum {number} */
export const LoginType = {
  SMS: 1,
  BigoLive: 2,
};

/**
 * 为代理用户获取并设置代理名称
 * @param {Object} userInfo - 用户信息对象
 * @returns {Promise<Object>} 返回更新后的用户信息
 */
export async function enrichAgentInfo(userInfo) {
  if (!userInfo) return;
  if (userInfo.role !== AccountRole.Agency) {
    try {
      const infoResult6645 = await bigoDbQryGetUserInfoFromServer6645({
        uids: [userInfo.bigoUid],
        other_attr: ['bigo_id'],
      });
      if (infoResult6645.code === STATUS_CODE.SUCCESS) {
        // 运营后台修改bigoid，也未能同步，这里需要同步
        userInfo.bigoId = infoResult6645.data[userInfo.bigoUid].other_attr_val.bigo_id;
      }
    } catch (err) {
      console.log('err', err);
    }
  } else {
    const [err, infoResult] = await catchError(
      brpcAnchorBrokerFrontQryAgentInfo({
        seqid: Number(new Date().getTime()),
      }),
    );

    if (!err && infoResult?.code === STATUS_CODE.SUCCESS) {
      userInfo.username = infoResult.data.agent_name;
      userInfo.bigoId = infoResult.data.from_bigoid;
    }

    return userInfo;
  }
}

const authApi = {
  /**
   * 发送验证码
   * @param {Object} data
   * @param {string} data.account
   * @param {string} data.password
   * @param {LoginType} data.type
   */
  sendLoginVerifyCode(data) {
    return http.post('/agent/user/getVerifyCode', data);
  },
  /**
   * 登录
   * @param {Object} data
   * @param {string} data.account
   * @param {string} data.password
   * @param {string} data.code
   * @param {LoginType} data.type
   */
  login(data) {
    return http.post('/agent/user/login', data);
  },
  /**
   * 刷新token
   * @param {string} token
   */
  refreshToken(token) {
    return http.post('agent/account/refreshToken', { token });
  },
  /**
   * 获取区域列表
   */
  getRegions() {
    return http.get('/agent/permission/getRegions');
  },

  /**
   * 获取当前用户信息
   */
  getUserInfo() {
    return http.get('/agent/user/info');
  },
};

export default authApi;
